"use client";

import { useQuery } from '@tanstack/react-query'
import { getApi } from "@src/config/apiWithAxios"
import { URL_GET_DETAIL_OFFICE } from "@src/constant/api-url"
import { KEY_COMPANY_DETAILS } from "@src/constant/query-keys/global"

const getCompanyDetails = async ({ queryKey }) => {
  const { requestUrl, slug } = queryKey[1];
  
  if(!slug) return null;

  const res = await getApi(requestUrl);

  return res?.data?.data
}

export const useQueryCompanyDetails = (slug) => {
  const dependencies = {
    requestUrl: URL_GET_DETAIL_OFFICE.replace(":slug", slug),
    slug
  }

  return useQuery({
    queryKey: [KEY_COMPANY_DETAILS, dependencies],
    queryFn: getCompanyDetails
  })
}
